<template>

    <div class="w-full">
        <!-- polling -->
        <div class="bg-grey-lighter text-center py-5" v-if="polling">
            <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
        </div>

         <!-- no chasers online -->
        <div class="bg-white border-l-4 border-blue-500 p-4 rounded mb-4 shadow" role="alert">
            <p>Update: To take streams to air, you must first press the button "Unlock Stream." This will then allow you to copy the rtmp url or open the video in a separate window without watermark.</p>
        </div>

        <!-- no chasers online -->
        <div class="bg-white border-l-4 border-red-500 text-red-700 p-4 rounded mb-4 shadow" role="alert" v-if="!polling" v-show="(chasers.length == undefined) || (chasers.length == 0)">
            <p>All chasers are currently offline. Please check back later!</p>
        </div>

        <h2 class="text-lg font-semibold px-2 py-2"  v-if="unlockedStreams.length !== 0">Your unlocked streams</h2>
        <CustomTable class="shadow-md mb-4" v-if="unlockedStreams.length !== 0">
            <template v-slot:header>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Description</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">RTMP</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Expires</th>
            </template>
            <template v-slot:body>
                <tr class="hover:bg-grey-lighter" v-for="stream in unlockedStreams">
                    <td class="py-4 px-6 border-b border-grey-light">{{ stream.description }}</td>
                    <td class="py-4 px-6 border-b border-grey-light">{{ 'rtmp://stream.livestormsvideo.com/live/' + stream.stream_id + '?token=' + stream.secure_id }}</td>
                    <td class="py-4 px-6 border-b border-grey-light">{{ stream.expires_at | timeAgo}}</td>
                </tr>
            </template>
        </CustomTable>

    <h2 class="text-lg font-semibold px-2 py-2"  v-if="unlockedStreams.length !== 0">Active Chasers</h2>
        <!-- chasers -->
        <div class="flex flex-wrap -mx-2"> 
            <!-- mt-5 -->
            <div class="w-full lg:w-1/2 px-2 mb-5" v-for="chaser in chasers">
                <div class="bg-white rounded shadow-md">
                    <div class="flex items-center content-center p-4">
                        <div class="w-1/2">
                            <strong class="text-lg">{{ chaser.user.name }}</strong>
                        </div>
                        <div class="w-1/2">
                            <div class="flex relative inline-block float-right">
                                <span class="bg-gray-600 rounded text-white px-3 font-bold text-sm" v-if="chaser.user.location == null">Location unavailable</span>
                                <span class="ml-2 bg-green-600 rounded text-white px-3 py-1 font-bold text-sm" v-if="chaser.user.location !== null"><i class="fas fa-map-marker-alt pr-1"></i> {{ chaser.user.location.location_text }}</span>
                                <span class="ml-2 bg-red-600 rounded text-white px-3 py-1 font-bold text-sm"><i class="fas fa-video pr-1"></i> LIVE</span>
                            </div>
                        </div>
                    </div>
                    <div class="embed-responsive embed-responsive-16by9 bg-black">
                        <StreamPlayer :streamId="chaser.stream_id" :ads="false" :watermark="true" class="embed-responsive-item" />
                    </div>
                    <div class="w-full bg-blue-700 text-center text-white py-2 font-semibold" style="border-radius: 0px; cursor: pointer; outline: 0;" v-on:click="openStream(chaser)" v-if="checkIfIsUnlocked(chaser.stream_id)">
                        Pop Out Stream <i class="fas fa-external-link-alt pl-2 text-sm"></i> 
                    </div>
                    <div class="w-full p-4">
                        <button class="w-full py-2 bg-blue-600 focus:outline-none text-white font-semibold rounded" v-on:click="unlockStream(chaser)" v-if="!checkIfIsUnlocked(chaser.stream_id)">
                            <span v-if="!unlocking">
                                Unlock Stream
                            </span>
                            <span v-if="unlocking">
                                <i class="fa fa-circle-notch fa-spin logging-in"></i>
                            </span>
                        </button>
                        <input
                            type="text"
                            class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-1 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest"
                            :value="'rtmp://stream.livestormsvideo.com/live/' + chaser.stream_id + '?token=' + getToken(chaser.stream_id)"
                            v-if="checkIfIsUnlocked(chaser.stream_id)"
                        />
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
			
</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import StreamPlayer from './components/StreamPlayer'
    import StreamUrl from './components/StreamUrl'
    import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'Chasers',
		data () {
			return {
                chasers: {},
                polling: true,
                interval: null,
                unlocking: false,
                unlockedStreams: []
			}
        },
        components: {
            StreamPlayer,
            StreamUrl,
            CustomTable
        },
        mounted() {
            this.getChasers();
            this.getUnlockedStreams();
    
            this.interval = setInterval(function () {
                this.getChasers();
            }.bind(this), 3000);
        },
        beforeDestroy: function() {
            clearInterval(this.interval);
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getChasers() {
                this.$http.get("https://api.livestormchasing.com/api/v1/chasers/cdn").then((response) => {
                    this.$set(this, 'chasers', response.data);
                    this.$set(this, 'polling', false);
                });
            },
            unlockStream(chaser) {
                this.unlocking = true

                var self = this;
                this.$http.post(Config.apiPath + "/api/v2/media/stream/unlock", {
                    streamId: chaser.stream_id,
                    chaser: chaser.user.name,
                }, this.getAuthorizationHeader())
                    .then((response) => {
                        self.unlocking = false
                        self.unlockedStreams.push(response.data)
                    })
            },
            getUnlockedStreams() {
                var self = this;
                this.$http.get(Config.apiPath + "/api/v2/media/stream/active", this.getAuthorizationHeader())
                    .then((response) => {
                        self.unlockedStreams = response.data
                    })
            },
            openStream(chaser) {
                var token = null
                window.open("https://cdn.livestormsvideo.com/media/stream/" + chaser.stream_id + "?token=" + this.getToken(chaser.stream_id) + "&name=" + chaser.user.name, '_blank', 'height=720,width=1280');
            },

            checkIfIsUnlocked(streamId) {
                return this.unlockedStreams.filter(stream => {
                    return stream.stream_id == streamId
                }).length > 0 ? true : false
            },

            getToken(streamId) {
               return this.unlockedStreams.filter(stream => {
                    return stream.stream_id == streamId
                })[0]['secure_id']
            }
        },
        filters: {
            displayDate: function(data) {
                return moment.utc(data).local().format('MM/DD/YY');
            },
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
        }
	}
</script>

<style scoped>
    .embed-responsive {
        position: relative;
        display: block;
        width: 100%;
        padding: 0;
        overflow: hidden;
    }

    .embed-responsive-16by9::before {
        padding-top: 56.25%;
    }

    .embed-responsive::before {
        display: block;
        content: "";
    }

    .embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
